type AttributeValueMappings = {
  cardIcons?: Record<string, string>;
  names: Record<string, string>;
  productImages?: Record<string, string>;
  softcoverProductImages?: Record<string, string>;
  hardcoverProductImages?: Record<string, string>;
};

export const ATTRIBUTE_VALUE_MAPPINGS_BY_KEY: Record<string, AttributeValueMappings> = {
  coverType: {
    names: {
      HCIW: "Hardcover, Image Wrap",
      SCIW: "Softcover, Image Wrap",
    },
    productImages: {
      HCIW: "/assets/images/cover-types/product-images/hardcover-imagewrap.png",
      SCIW: "/assets/images/cover-types/product-images/softcover-imagewrap.png",
    },
  },
  coverFinish: {
    names: {
      GL: "Gloss",
      MT: "Matte",
    },
    softcoverProductImages: {
      GL: "/assets/images/cover-finishes/product-images/softcover/gloss.png",
      MT: "/assets/images/cover-finishes/product-images/softcover/matte.png",
    },
    hardcoverProductImages: {
      GL: "/assets/images/cover-finishes/product-images/hardcover/gloss.png",
      MT: "/assets/images/cover-finishes/product-images/hardcover/matte.png",
    },
  },
  bindType: {
    names: {
      STD: "Glue Bound (Standard)",
    },
    softcoverProductImages: {
      STD: "/assets/images/bind-types/product-images/softcover/glue.png",
    },
    hardcoverProductImages: {
      STD: "/assets/images/bind-types/product-images/hardcover/glue.png",
    },
  },
  textStock: {
    names: {
      "100T": "100 lbs Gloss Finish",
    },
    productImages: {
      "100T": "/assets/images/paper-types/product-images/100_gloss.png",
    },
  },
  dimensions: {
    cardIcons: {
      "7.750x9.750IN": "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      "8.000x10.000IN": "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      "8.000x8.000IN": "/assets/images/book-orientation/book-sizes/orientation_square.png",
      "7.750x7.750IN": "/assets/images/book-orientation/book-sizes/orientation_square.png",
      "8.250x10.750IN": "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      "8.500x11.000IN": "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      "10.750x8.250IN": "/assets/images/book-orientation/book-sizes/orientation_landscape.png",
      "11.000x8.500IN": "/assets/images/book-orientation/book-sizes/orientation_landscape.png",
      "11.750x11.750IN": "/assets/images/book-orientation/book-sizes/orientation_square.png",
    },
    // Hardcover books will have a slightly smaller book block for the same book size
    // this is why we have 8x11 exact for softcover and 8.25x10.75 for hardcover
    names: {
      "7.750x9.750IN": "7.75x9.75 in",
      "8.000x10.000IN": "8x10 in",
      "8.000x8.000IN": "8x8 in",
      "7.750x7.750IN": "7.75x7.75 in",
      "8.250x10.750IN": "8.25x10.75 in",
      "8.500x11.000IN": "8.5x11 in",
      "10.750x8.250IN": "10.75x8.25 in",
      "11.000x8.500IN": "11x8.5 in",
      "11.750x11.750IN": "11.75x11.75 in",
    },
  },
  orientation: {
    cardIcons: {
      LANDSCAPE: "/assets/images/book-orientation/book-sizes/orientation_landscape.png",
      PORTRAIT: "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      SQUARE: "/assets/images/book-orientation/book-sizes/orientation_square.png",
    },
    names: {
      LANDSCAPE: "Landscape",
      PORTRAIT: "Portrait",
      SQUARE: "Square",
    },
  },
};

export function getCardIconPath(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.cardIcons?.[attributeValue];
}

export function getDisplayName(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.names[attributeValue];
}

export function getProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.productImages?.[attributeValue];
}

export function getSoftcoverProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.softcoverProductImages?.[attributeValue];
}

export function getHardcoverProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.hardcoverProductImages?.[attributeValue];
}
